import { Inline, Text, useId } from '@lessonnine/design-system.lib';
import omit from 'lodash/fp/omit';
import PropTypes from 'prop-types';
// External Imports
import React from 'react';

import { LANGUAGES } from '../../config/types/prop.mjs';
import { DisclosureMenu } from '../DisclosureMenu/DisclosureMenu.jsx';
import { DisclosureMenuLink } from '../DisclosureMenu/DisclosureMenuLink.jsx';
// Internal Imports
import { I18n } from '../I18n/I18n.jsx';

// Component Definition
function EditionPicker({ currentEdition, editions }) {
  const labelId = useId();
  const filteredEditions = omit([currentEdition], editions);
  const menuItems = Object.keys(filteredEditions).map((languageCode) => {
    const { link, name } = editions[languageCode];
    return (
      <DisclosureMenuLink key={languageCode} to={link}>
        {name}
      </DisclosureMenuLink>
    );
  });

  const labelItem = (
    <Text fontSize="medium" fontWeight={500}>
      {editions[currentEdition]?.name}
    </Text>
  );

  if (editions[currentEdition]) {
    return (
      <Inline alignItems="center" gap={15}>
        <Text
          fontSize={{ medium: 'medium', small: 'small' }}
          fontWeight={600}
          id={labelId}
          letterSpacing="0.06"
        >
          <I18n defaultText="BABBEL MAGAZINE EDITION" field="babbel-magazine-edition" />
        </Text>
        <DisclosureMenu items={menuItems} label={labelItem} navLabelId={{ id: labelId }} />
      </Inline>
    );
  }

  // eslint-disable-next-line unicorn/no-null -- expected return for empty component with React
  return null;
}

EditionPicker.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  editions: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types -- dynamically built
};

// Module Exports
export { EditionPicker };
